if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        this.initGallery();
        this.picList = Array.from(this.querySelectorAll('.product__media-item'));
      }

      initGallery() {
        // Add an event listener to EACH thumbnail button in the component
        const thumbnailButtons = this.elements.thumbnails.querySelectorAll('button');
        thumbnailButtons.forEach((btn) => {
          btn.addEventListener('click', (e) => {
            const mediaId = btn.dataset.mediaId;
            this.setActiveMedia(mediaId);
            btn.focus();
          });
        });

        // Ensure first thumbnail is outlined on page load
        if (thumbnailButtons.length > 0 && !this.elements.thumbnails.querySelector('.is-active')) {
          thumbnailButtons[0].classList.add('is-active');
          thumbnailButtons[0].setAttribute('aria-current', true);
        }

        // Keyboard navigation for thumbnails
        if (this.elements.thumbnails) {
          this.elements.thumbnails.addEventListener('keydown', (e) => {
            const activeBtn = this.elements.thumbnails.querySelector('.is-active');
            if (!activeBtn) return;
            let nextBtn;
            if (e.key === 'ArrowRight') {
              nextBtn = activeBtn.nextElementSibling;
            } else if (e.key === 'ArrowLeft') {
              nextBtn = activeBtn.previousElementSibling;
            }
            if (nextBtn) {
              nextBtn.focus();
              this.setActiveMedia(nextBtn.dataset.mediaId);
              e.preventDefault();
            }
          });
        }

        // Add event listeners to the Next/Prev buttons
        this.querySelectorAll('.slider-button--prev').forEach((btn) => btn.addEventListener('click', () => this.goToPrevious()));
        this.querySelectorAll('.slider-button--next').forEach((btn) => btn.addEventListener('click', () => this.goToNext()));
      }

      goToPrevious() {
        const activeIndex = this.picList.findIndex((item) => item.classList.contains('is-active'));
        let prevIndex = activeIndex - 1;
        if (prevIndex < 0) prevIndex = this.picList.length - 1;
        this.setActiveMedia(this.picList[prevIndex].getAttribute('data-media-id'));
      }

      goToNext() {
        const activeIndex = this.picList.findIndex((item) => item.classList.contains('is-active'));
        let nextIndex = activeIndex + 1;
        if (nextIndex >= this.picList.length) nextIndex = 0;
        this.setActiveMedia(this.picList[nextIndex].getAttribute('data-media-id'));
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
    
        if (!activeMedia) {
          return;
        }
        
        // Assign is-active to gallery mesia
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          (element === activeMedia) ? element.classList.add('is-active') : element.classList.remove('is-active');
        });

        // Assign media position to counter
        const counterElement = this.elements.viewer.querySelector('.slider-counter--current');
        counterElement.textContent = activeMedia.dataset.mediaPosition;

        // Highlight active thumbnail
        const thumbnailBtn = this.querySelector(`.gallery-thumbnail-btn[data-media-id="${mediaId}"]`);
        this.setActiveThumbnail(thumbnailBtn);

        // Scroll thumbnail into view
        if (thumbnailBtn && thumbnailBtn.scrollIntoView) {
          thumbnailBtn.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        }

        // Prepend mobile active media to start of list
        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();

        // Scroll to active media
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // // Don't scroll if the image is already in view
          // if (activeMediaRect.top < -30 || activeMediaRect.top > 0) return;
          // const top = activeMediaRect.top + window.scrollY;
          // window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        this.announceLiveRegion(activeMedia, activeThumbnail?.dataset?.mediaPosition);
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      

      setActiveThumbnail(thumbnail) {
        const thumbnailButtons = this.elements.thumbnails.querySelectorAll('.gallery-thumbnail-btn');
        thumbnailButtons.forEach((btn) => {
          btn.classList.remove('is-active');
          btn.setAttribute('aria-current', false);
        });
        if (thumbnail) {
          thumbnail.classList.add('is-active');
          thumbnail.setAttribute('aria-current', true);
        }
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        // Pause all <video> and <audio> elements in the gallery
        const mediaGallery = this;
        mediaGallery.querySelectorAll('video, audio').forEach((media) => {
          if (!media.paused) media.pause();
        });
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}